import "./tabs.scss";

const Tabs = ({ data, onChange, active, lang }) => {
  return (
    <div className="tabs d-flex justify-content-around">
      {data?.map((item) => (
        <button
          key={`tab-${item.name.en}`}
          aria-label="change to"
          onClick={() => {
            onChange(item);
          }}
          data-active={active === item}
        >
          {item.name[lang]}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
